// module_configs/salanty.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faDollarSign, faUsersCog, faClock
} from '@fortawesome/free-solid-svg-icons';

// Import Salanty components
import DashboardHome from '.././module_salanty/Dashboard/Dashboard_PO';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';

export const salantyConfig = {
  moduleId: 'salanty',
  moduleName: 'Salanty',
  icon: faDollarSign,
  description: 'Salanty & Financial Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_salanty': { level: 1, label: 'Admin', color: '#f59e0b' },
    'manager_salanty': { level: 2, label: 'Manager', color: '#d97706' },
    'user_salanty': { level: 3, label: 'User', color: '#b45309' },
    'viewer_salanty': { level: 4, label: 'Viewer', color: '#92400e' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_salanty'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_salanty', 'manager_salanty', 'user_salanty'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$5,200' },
    { id: 'orders', label: 'Orders', icon: 'faShoppingCart', value: 67 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 34 },
    { id: 'pending', label: 'Pending', icon: 'faClock', value: 4 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};